import React, { useEffect } from "react";
import { Box } from "@mui/material";

// Importa los componentes de la carpeta Tienda
import Promociones from "../components/Tienda/Promociones";
import Catalogos from "../components/Tienda/Catalogos";

export default function TiendaPage() {
  useEffect(() => {
    // Al entrar a la página, el scroll sube automáticamente
    window.scrollTo(0, 0);
    document.title = "Tienda | Eléctrica GRM";
  }, []);

  return (
    <Box>
      <Promociones />
      <Catalogos />
    </Box>
  );
}
